/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/
import { createClient, MemoryStore } from "matrix-js-sdk";
import type { Session, InitResult } from "../ClientContext";
import { Config } from "../config/Config";
import { sessionHomeserver } from "./sessionHomeserver";

/** Recordings need authenticated HTTP requests, not Matrix sync or crypto stores. */
export function initRecordingClient(
  loadSession: () => Session | undefined,
  search: string,
): InitResult | null {
  if (new URLSearchParams(search).has("share")) return null;
  const session = loadSession();
  if (!session) return null;
  const client = createClient({
    baseUrl: sessionHomeserver(
      session,
      Config.defaultHomeserverUrl(),
      Config.defaultServerName(),
    ),
    userId: session.user_id,
    deviceId: session.device_id,
    accessToken: session.access_token,
    store: new MemoryStore(),
    useAuthorizationHeader: true,
    localTimeoutMs: 10000,
  });
  // StaffGate and every backend endpoint still verify the live token and permissions.
  // Never start this client: it must not contend with a call tab's IndexedDB/crypto.
  return {
    client,
    widgetApi: null,
    passwordlessUser: session.passwordlessUser,
  };
}
